<template>
  <div :style="style" class="control-container">
    <div class="control-row title">
        <CktextComponent :rawHtml="control.data.data.title">    
        </CktextComponent>
        <div v-if="control.data.data.misc.required" class="required">*</div>
    </div>
    <div class="control-row">
        <CktextComponent :rawHtml="control.data.data.subtitle">    
        </CktextComponent>
    </div>
    <div class="control-row">
        <Calendar v-model="date" :showTime="false" :touchUI="true" :showIcon="true" :class="{'p-invalid':submitted&&!valid}"/>
    </div>
    <div class="control-row p-error" v-if="submitted&&!requiredvalid">
        {{titleinnertext}}{{ $t('message.is_required') }}
    </div>    
  </div>
</template>

<script>
import Calendar from 'primevue/calendar';
import CktextComponent from '../CkText.vue';

export default {
  name: 'DateControl',
  components: {
    Calendar,
    CktextComponent
  },
  data(){
    return {
      titleinnertext:'',
      requiredvalid:true,
      valid:true,
      style:'',
      date:null,
      submitted:false
    }
  },
  props: {
    control: null
  },
  methods:{
    validateData(){

      this.submitted=true;

      this.requiredvalid=(this.date&&this.control.data.data.misc.required)||!this.control.data.data.misc.required

      this.valid=this.requiredvalid;

      return {
        valid:this.valid,
        data:this.date,
        type:1
      };

    }
  },
  created(){
    
    this.style=this.$common.generateStyle(this.control.data.style);

    this.titleinnertext=this.$common.stripHtml(this.control.data.data.title);

    if(this.control.data.data.autodate)
      this.date=new Date();

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.control-container:last-child{
      margin-bottom: 0px;
  }
  .control-row{
      margin-bottom: 10px;
      text-align:left;
  }

  .title{
      display: flex;
  }
  .required{
    color:#f7363f;
  }   
  .p-calendar{
    width:100%;
  }
</style>